import down from "./down";
import left from "./left";
import right from "./right";

export const chevron = {
  "chevron/down": down,
  "chevron/left": left,
  "chevron/right": right,
};
